import { IconProps } from './IconProps';

/** Figma "question/question-mark-circle" — the info affordance on the MAX step. */
export const QuestionMarkCircleIcon = (props: IconProps) => {
  return (
    <svg
      className={props.className}
      style={props.style}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        opacity="0.8"
        d="M8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0Z"
        fill={props.fill ?? '#505050'}
      />
      <path
        d="M5.82617 6.17507C5.82617 4.97395 6.79987 4.00024 8.001 4.00024C9.20212 4.00024 10.1758 4.97395 10.1758 6.17507C10.1758 6.94007 9.78083 7.61282 9.18368 8.00051C8.60448 8.37653 8.001 8.90969 8.001 9.60024M8.00099 12.0002H8.00179"
        stroke="white"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
